import { Flame, Sparkles, ChevronRight } from "lucide-react";

export default function AnnouncementBar({ businessName, fee }) {
    const items = [
        { icon: Flame, text: "LIMITED OFFER" },
        { icon: Sparkles, text: businessName || "Energy Plus Premium Brown Eggs" },
        { icon: ChevronRight, text: `Seminar Fee — Only ₹${fee || "199"}` },
        { icon: Flame, text: "Register Now · Limited Seats" },
    ];
    const track = [...items, ...items, ...items, ...items];
    return (
        <div
            data-testid="announcement-bar"
            className="relative bg-orange-gradient text-white overflow-hidden py-2.5 shadow-orange"
        >
            <div className="flex whitespace-nowrap animate-marquee gap-10 text-sm font-bold uppercase tracking-wider">
                {track.map((it, i) => {
                    const Ico = it.icon;
                    return (
                        <span key={i} className="flex items-center gap-3 pr-6 shrink-0">
                            <Ico className="w-4 h-4 shrink-0" />
                            <span>{it.text}</span>
                            <span className="text-white/50">•</span>
                        </span>
                    );
                })}
            </div>
        </div>
    );
}
